import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import HandymanIcon from '@mui/icons-material/Handyman';
import GrassIcon from '@mui/icons-material/Grass';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';

// export const logo = 'https://i.ibb.co/s9Qys2j/logo.png';

export const categories = [
  { name: 'New', icon: <HomeIcon />, },
  { name: 'JavaScript', icon: <CodeIcon />, },
  { name: 'JS Mastery', icon: <CodeIcon />, },
  { name: 'ReactJS', icon: <CodeIcon />, },
  { name: 'NextJS', icon: <CodeIcon />, },
  { name: 'NodeJS', icon: <CodeIcon />, },
  { name: 'API', icon: <CodeIcon />, },
  { name: 'Hot Ones', icon: <LocalFireDepartmentIcon />, },
  { name: 'Music', icon: <MusicNoteIcon /> },
  { name: 'Eating Healthy', icon: <RestaurantIcon />, },
  { name: 'Workout', icon: <FitnessCenterIcon />, },
  { name: 'Yoga', icon: <SelfImprovementIcon />, },
  { name: 'Comedy', icon: <TheaterComedyIcon />, },
  { name: 'Home Renovation', icon: <HandymanIcon />, },
  { name: 'Awesome Gardens', icon: <GrassIcon />, },
  { name: 'Best Beaches', icon: <BeachAccessIcon />, },
  { name: 'MndBdy', icon: <OndemandVideoIcon />, },
];

export const demoThumbnailUrl = 'https://i.ibb.co/G2L2Gwp/API-Course.png';
export const demoChannelUrl = '/channel/UCmXmlB4-HJytD7wek0Uo97A';
export const demoVideoUrl = '/video/GDa8kZLNhJ4';
export const demoChannelTitle = 'JavaScript Mastery';
export const demoVideoTitle = 'Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI';
export const demoProfilePicture = 'http://dergipark.org.tr/assets/app/images/buddy_sample.png'